import { FunctionComponent, useCallback } from "react";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { ExternalIcon } from "@icons/ExternalIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { useAppDispatch, useAppSelector } from "@store/store";
import {
  selectIsMediaActive,
  selectIsPlayingMedia,
  setIsPlayingAction,
  setMediaAction,
} from "@store/media/mediaReducer";
import type { Place } from "@dto/Place";
import type { Tour } from "@dto/Tour";
import type { Event } from "@dto/Event";
import { useTranslation } from "react-i18next";
import { Goal } from "@dto/Goal";
import { FeedPost } from "@dto/FeedPost";

interface MediaPlayerProps {
  entity: Place | Tour | Event | Goal | FeedPost;
}

const VideoPlayerButton: FunctionComponent<MediaPlayerProps> = ({ entity }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const entityMedia = entity.videoMediaFiles?.[0];
  const isPlaying = useAppSelector(
    selectIsPlayingMedia(entityMedia?.streamUrl),
  );
  const isMediaActive = useAppSelector(
    selectIsMediaActive(entityMedia?.streamUrl),
  );

  const handlePress = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();
      if (isMediaActive) {
        dispatch(setIsPlayingAction(!isPlaying));
      } else {
        dispatch(
          setMediaAction({
            ...entityMedia,
            streamUrl:
              "https://dfht7c9lgb1wh.cloudfront.net/attachments/clients/861/video_media_files/16783/file/stream.m3u8?cache_version=1659873981",
            title: entity?.name ?? "",
          }),
        );
      }
    },
    [dispatch, entity?.name, entityMedia, isMediaActive, isPlaying],
  );

  if (!entityMedia /* || !entityMedia.streamUrl */) {
    return null;
  }

  return (
    <div>
      <TabButton
        label={t("common.watch")}
        variant="inverseTranslucent"
        iconPrefix={
          <ExternalIcon
            svgName={isPlaying ? "pause" : "play"}
            size={16}
            color={colors.neutral700}
          />
        }
        onPress={handlePress}
      />
    </div>
  );
};

export { VideoPlayerButton };
